import { useCallback } from "react";

import styled from "styled-components";
import { themeVariants } from "theme";
import padding from "theme/interpolations/padding";

import TwoFA from "Login/TwoFA";
import { variants } from "Login/TwoFA/constants";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import { useSetClientAuthState } from "../../stateHooks";
import { useSetAuthToLoggedIn } from "../VerifyCode/useSetAuthToLoggedIn";

const Padding = styled("div")`
  ${padding};
`;

export default function RequestCode() {
  const setAuthToLoggedIn = useSetAuthToLoggedIn();
  const {
    dispatch,
    state: {
      tabID,
      isMobile,
      fund: { fundColorSafe },
      recurringPayment: { recurring },
    },
  } = usePaymentPage();

  const skipAuth = useCallback(
    ({ firstFactorType, firstFactor }) => {
      // we need these values when submitting a payment method when not logging in.
      dispatch({
        type: "setAuthEmailOrPhone",
        loginValueType: firstFactorType,
        loginValue: firstFactor,
      });
      setAuthToLoggedIn({ authSkipped: true });
    },
    [dispatch, setAuthToLoggedIn]
  );

  const setClientAuthState = useSetClientAuthState();

  return (
    <Padding $variant={themeVariants.container}>
      <TwoFA
        headerText={false}
        showNetwork={false}
        width={isMobile ? "100%" : "264px"}
        variant={variants.give}
        skipAuth={skipAuth}
        noSkipAuthMessage={
          Boolean(recurring) && "Log in to make recurring payments."
        }
        onSuccess={setClientAuthState}
        tabID={tabID}
        accentColor={fundColorSafe}
        animateEntranceHeight
        stoutInputs
      />
    </Padding>
  );
}
